/// <reference types="./advisoryLockAcquire.d.ts" />
import { notOk, ok } from '@dossierhq/core';
import { buildSqliteSqlQuery } from '@dossierhq/database-adapter';
import { AdvisoryLocksUniqueNameConstraint } from '../DatabaseSchema.js';
import { queryRun } from '../QueryFunctions.js';
import { getTransactionTimestamp } from '../SqliteTransaction.js';
export async function advisoryLockAcquire(database, context, name, handle, leaseDuration) {
    const now = getTransactionTimestamp(context.transaction);
    const expires_at = now.getTime() + leaseDuration;
    const query = buildSqliteSqlQuery(({ sql, addValue }) => {
        const nowValue = addValue(now.toISOString());
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        sql `INSERT INTO advisory_locks (name, handle, acquired_at, renewed_at, expires_at, lease_duration)
        VALUES (${name}, ${handle}, ${nowValue}, ${nowValue}, ${expires_at}, ${leaseDuration})`;
    });
    const result = await queryRun(database, context, query, (error) => {
        if (database.adapter.isUniqueViolationOfConstraint(error, AdvisoryLocksUniqueNameConstraint)) {
            return notOk.Conflict(`Lock with name '${name}' already exists`);
        }
        return notOk.GenericUnexpectedException(context, error);
    });
    if (result.isError())
        return result;
    return ok({ acquiredAt: now });
}
//# sourceMappingURL=advisoryLockAcquire.js.map